<div class="left-container">
    <div class="login-initialLoading-div">
        <img alt="loading" src="../../assets/images/spinner.gif"/>
    </div>
</div>